import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

type GetAccentraStatusRequest = {
  buildingId: number
}

type AccentraStatus = {
  isConnected: boolean
}

export const getAccentraStatusQueryKey = (data: GetAccentraStatusRequest) => [
  'useGetAccentraStatus',
  data,
]

const getAccentraStatus = async (data: GetAccentraStatusRequest) => {
  const response = await authAPI.get<AccentraStatus>(
    `/building/${data.buildingId}/accentra-integration/status`,
  )
  return response.data
}

export const useGetAccentraStatus = (data: GetAccentraStatusRequest) =>
  useQuery({
    enabled: Boolean(data.buildingId),
    queryFn: () => getAccentraStatus(data),
    queryKey: getAccentraStatusQueryKey(data),
  })
